import React from "react";
import { Moon, Sun, Monitor } from "lucide-react";
import { useTheme } from "../context/ThemeProvider";

export const ThemeToggle: React.FC = () => {
  const { theme, resolvedTheme, setTheme, toggle } = useTheme();

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={toggle}
        className="inline-flex items-center gap-2 rounded-2xl border px-3 py-1 text-sm transition
                   bg-white hover:bg-gray-50 border-gray-200 text-gray-700
                   dark:bg-gray-900 dark:hover:bg-gray-800 dark:border-gray-700 dark:text-gray-200"
        title={`Passer en ${resolvedTheme === "dark" ? "light" : "dark"}`}
      >
        {resolvedTheme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
        <span className="hidden sm:inline">{resolvedTheme === "dark" ? "Light" : "Dark"}</span>
      </button>

      <div className="hidden sm:flex rounded-2xl overflow-hidden border border-gray-200 dark:border-gray-700">
        <button
          onClick={() => setTheme("light")}
          className={`px-2 py-1 text-sm ${theme==="light" ? "bg-gray-100 dark:bg-gray-800" : ""}`}
          title="Light"
        >
          <Sun className="w-4 h-4" />
        </button>
        <button
          onClick={() => setTheme("system")}
          className={`px-2 py-1 text-sm ${theme==="system" ? "bg-gray-100 dark:bg-gray-800" : ""}`}
          title="System"
        >
          <Monitor className="w-4 h-4" />
        </button>
        <button
          onClick={() => setTheme("dark")}
          className={`px-2 py-1 text-sm ${theme==="dark" ? "bg-gray-100 dark:bg-gray-800" : ""}`}
          title="Dark"
        >
          <Moon className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

// ✅ export par défaut aussi
export default ThemeToggle;
